export const locale = {
  lang: "de",
  data: {
    TITLE: "Wartungsarbeiten!",
    SUBTITLE:
      "Bitte entschuldigen Sie die Unannehmlichkeiten. <br /><br />  Bitte kontaktieren Sie Ihren Administrator."
  }
};
